var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.277,
    height: 44.277,
    viewBox: "0 0 44.277 44.277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16633",
    "data-name": "Grupo 16633",
    transform: "translate(-531.419 -1917)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1556",
    "data-name": "Elipse 1556",
    cx: 7.519,
    cy: 7.519,
    r: 7.519,
    transform: "translate(546.107 1922.848)",
    fill: "#fc287e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104964",
    "data-name": "Trazado 104964",
    d: "M6983.965,1927.86l-6.218,4.735,6.218,5.263Z",
    transform: "translate(-6445.218 -1.787)",
    fill: "#58948f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104965",
    "data-name": "Trazado 104965",
    d: "M6977.747,1927.86l6.218,4.735-6.218,5.263Z",
    transform: "translate(-6409.793 -1.787)",
    fill: "#58948f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104963",
    "data-name": "Trazado 104963",
    d: "M6977.707,1965.5l21.253-16.745,20.423,16.745Z",
    transform: "translate(-6445.211 -5.226)",
    fill: "#b1e0de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104961",
    "data-name": "Trazado 104961",
    d: "M6977.707,1933.96l17.77,14.677-17.77,14.426Z",
    transform: "translate(-6445.211 -2.791)",
    fill: "#b1e0de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104962",
    "data-name": "Trazado 104962",
    d: "M6995.477,1933.96l-17.77,14.677,17.77,14.426Z",
    transform: "translate(-6419.78 -2.791)",
    fill: "#b1e0de"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_9-Mail",
    transform: "translate(531.419 1917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15471",
    "data-name": "Grupo 15471",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_75946",
    "data-name": "Trazado 75946",
    d: "M54.886,23.885,48.8,18.961V12.054A1.054,1.054,0,0,0,47.749,11H18.529a1.054,1.054,0,0,0-1.054,1.054v6.908l-6.083,4.923A1.055,1.055,0,0,0,11,24.7V54.223a1.054,1.054,0,0,0,1.054,1.054H54.223a1.054,1.054,0,0,0,1.054-1.054V24.7A1.055,1.055,0,0,0,54.886,23.885Zm-41.778,3.1L28.361,39.949,13.108,52.042Zm20.03,11.868L51.2,53.169H15.081Zm4.778,1.1L53.169,26.984V52.042ZM52.572,24.725l-3.77,3.2V21.673ZM46.694,13.108V29.721L36.232,38.614,33.793,36.68a1.055,1.055,0,0,0-1.31,0l-2.439,1.934L19.583,29.721V13.108Zm-29.22,14.82-3.77-3.2,3.77-3.051Z",
    transform: "translate(-11 -11)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_75947",
    "data-name": "Trazado 75947",
    d: "M32.473,31.684a7.878,7.878,0,0,0,3.662-.907,1.054,1.054,0,0,0-.982-1.865A5.814,5.814,0,0,1,34,29.367a5.747,5.747,0,0,1-7.06-4,5.737,5.737,0,0,1,11.052-3.083,3.044,3.044,0,0,1-.854,2.956.492.492,0,0,1-.69-.1A7.521,7.521,0,0,1,35.534,22,2.986,2.986,0,0,0,32.1,19.9a4.636,4.636,0,0,0-3.5,2.873,3.621,3.621,0,0,0,.635,3.736,3.087,3.087,0,0,0,2.322,1.035,3.446,3.446,0,0,0,.931-.13,3.954,3.954,0,0,0,2.035-1.4l.011.024a2.471,2.471,0,0,0,1.707,1.431,2.623,2.623,0,0,0,2.248-.608,5.116,5.116,0,0,0,1.555-5.046c0-.01-.01-.018-.012-.028s0-.021,0-.032a7.846,7.846,0,1,0-7.56,9.931Zm.632-7.352a2.01,2.01,0,0,1-1.183,1.052A1.031,1.031,0,0,1,30.8,25.1a1.517,1.517,0,0,1-.241-1.548,2.56,2.56,0,0,1,1.8-1.558,1.531,1.531,0,0,1,.188-.011c.351,0,.791.111.91.445A4.146,4.146,0,0,1,33.105,24.331Z",
    transform: "translate(-10.261 -10.729)",
    fill: "#3b0310"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.c1762993b5146c4cdcc6b8c44ce2287e.svg";
export { ForwardRef as ReactComponent };